"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../../api/webAApi");
var EventBindingOnLevelCfgCtl = /** @class */ (function (_super) {
    __extends(EventBindingOnLevelCfgCtl, _super);
    function EventBindingOnLevelCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingOnLevelCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            is_bonus_create_on_less_or_eq_then_level_number: false,
            bonus_create_on_less_or_eq_then_level_number: 0,
            is_bonus_create_on_greater_then_level_number: false,
            bonus_create_on_greater_then_level_number: 0
        };
    };
    EventBindingOnLevelCfgCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandBonusEventBindingConfigOnLevelGet.exec({ event_binding_id: key }, function (resp) {
            _this.DATA.is_bonus_create_on_less_or_eq_then_level_number = resp.is_bonus_create_on_less_or_eq_then_level_number;
            _this.DATA.bonus_create_on_less_or_eq_then_level_number = resp.bonus_create_on_less_or_eq_then_level_number;
            _this.DATA.is_bonus_create_on_greater_then_level_number = resp.is_bonus_create_on_greater_then_level_number;
            _this.DATA.bonus_create_on_greater_then_level_number = resp.bonus_create_on_greater_then_level_number;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingOnLevelCfgCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandBonusEventBindingConfigOnLevel.exec({
            data: {
                event_binding_id: data.event_binding_id,
                is_bonus_create_on_less_or_eq_then_level_number: data.is_bonus_create_on_less_or_eq_then_level_number,
                bonus_create_on_less_or_eq_then_level_number: data.bonus_create_on_less_or_eq_then_level_number,
                is_bonus_create_on_greater_then_level_number: data.is_bonus_create_on_greater_then_level_number,
                bonus_create_on_greater_then_level_number: data.bonus_create_on_greater_then_level_number
            }
        }, function (resp) {
            _this.DATA.is_bonus_create_on_less_or_eq_then_level_number = data.is_bonus_create_on_less_or_eq_then_level_number;
            _this.DATA.bonus_create_on_less_or_eq_then_level_number = data.bonus_create_on_less_or_eq_then_level_number;
            _this.DATA.is_bonus_create_on_greater_then_level_number = data.is_bonus_create_on_greater_then_level_number;
            _this.DATA.bonus_create_on_greater_then_level_number = data.bonus_create_on_greater_then_level_number;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return EventBindingOnLevelCfgCtl;
}(BaseController_1.BaseController));
exports.EventBindingOnLevelCfgCtl = EventBindingOnLevelCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/event_config/config_on_level/EventBindingOnLevelCfgCtl.ts
// module id = 980
// module chunks = 0